import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import Header from '../../components/header';
import Head from '../../components/head';
import Footer from '../../components/footer';
import ListaLrf from '../../components/lrf/listar';


function LrfListScreen () {
    return (
        <Fragment>
            <Head titulo="Lei de Responsabilidade Fiscal"/>
            <Header />
            <Container>
                <ListaLrf />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default LrfListScreen;